/* global CompareUtil */

if (!customElements.get('product-equipment-options')) {
  class ProductEquipmentOptions extends HTMLElement {
    constructor() {
      super();
      this.clickHandler = this.handleClick.bind(this);
      this.outsideHandler = (event) => {
        if (this.help?.open && !this.help.contains(event.target)) this.help.open = false;
      };
      this.escapeHandler = (event) => {
        if (event.key !== 'Escape' || !this.help?.open) return;
        event.preventDefault();
        this.help.open = false;
        this.help.querySelector('summary').focus();
      };
    }

    connectedCallback() {
      this.help = this.querySelector('.option-selector__help');
      this.compareButton = this.querySelector('.js-equipment-compare');
      this.addEventListener('click', this.clickHandler);
      document.addEventListener('pointerdown', this.outsideHandler, true);
      document.addEventListener('click', this.outsideHandler, true);
      document.addEventListener('keydown', this.escapeHandler, true);
      if (!this.compareButton || !document.querySelector('compare-modal')) return;
      customElements.whenDefined('compare-modal').then(() => {
        if (this.isConnected) this.compareButton.disabled = false;
      });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
      document.removeEventListener('pointerdown', this.outsideHandler, true);
      document.removeEventListener('click', this.outsideHandler, true);
      document.removeEventListener('keydown', this.escapeHandler, true);
    }

    handleClick(event) {
      if (!event.target.closest('.js-equipment-compare') || this.compareButton.disabled) return;
      const drawer = document.querySelector('compare-drawer');
      const modal = document.querySelector('compare-modal');
      const status = this.querySelector('.product-equipment-options__compare-status');
      try {
        const products = JSON.parse(this.querySelector('.js-equipment-compare-products').textContent);
        if (!drawer || !modal || drawer.getMaxCompare() < 2 || products.length !== 2) {
          throw new Error('Equipment comparison unavailable');
        }
        this.help.open = false;
        status.hidden = true;
        CompareUtil.setSelectedProducts(products);
        CompareUtil.updateCompareCheckboxes();
        modal.dispatchEvent(new CustomEvent('on:product-compare-modal:open', {
          detail: { opener: this.compareButton, onlyDifferences: true }
        }));
      } catch (error) {
        status.textContent = status.dataset.error;
        status.hidden = false;
      }
    }
  }

  customElements.define('product-equipment-options', ProductEquipmentOptions);
}

if (!customElements.get('product-model-variants')) {
  customElements.define('product-model-variants', class extends customElements.get('product-equipment-options') {});
}
